import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useForm } from 'react-hook-form';
import NotificationAlert from 'componentes/generic/Notification.js';
import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
const URI = ApiEndpoint + 'administration/';
const URIConfig = ApiEndpoint + 'configuration/';
const EditDeterminante = ({ idDeterminante, idCustomer, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [states, setStates] = useState(null);
  const [municipios, setMunicipios] = useState(null);
  const [subCustomers, setSubCustomers] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(idCustomer);
  const [customers, setCustomers] = useState(null);

  const [isError, setIsError] = useState(true);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);
  const [selectedEstado, setSelectedEstado] = useState(null);
  const [formatosQueja, setFormatosQueja] = useState(null);
  const [selectedFormatoQueja, setSelectedFormatoQueja] = useState(null);

  const [selectedSubCustomer, setSelectedSubCustomer] = useState(null);
  const [selectedMunicipioDescription, setSelectedMunicipioDescription] =
    useState('');
  const [determinante, setDeterminante] = useState({
    idsubcliente: '',
    determinante: '',
    unidad: '',
    idmunicipio: 0,
    formatoqueja: 0
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URIConfig + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getMunicipiosList = async idState => {
    setMunicipios(null);

    httpClient('GET', URIConfig + 'cities/' + idState, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCustomers = async () => {
    setCustomers(null);

    httpClient('GET', URI + 'customers/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idcliente, label: item.razonsocial };
          });
          setCustomers(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getSubCustomers = async () => {
    setSubCustomers(null);

    httpClient(
      'GET',
      URI + 'subcustomers/' + selectedCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setSubCustomers(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getDeterminante = async () => {
    setDeterminante(null);

    httpClient(
      'GET',
      URI + 'determinante/' + idDeterminante,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setSelectedCustomer(response.data.subcliente.idcliente);
          setSelectedEstado(response.data.municipio.idestado);
          setSelectedSubCustomer(response.data.idsubcliente);
          setSelectedMunicipioDescription(response.data.municipio.descripcion);
          setSelectedFormatoQueja(response.data.idformatoqueja);
          setValue('idsubcliente', response.data.idsubcliente);
          setValue('idcustomer', response.data.subcliente.idcliente);
          setValue('determinante', response.data.determinante);
          setValue('unidad', response.data.unidad);
          setValue('idmunicipio', response.data.idmunicipio);
          setValue('formatoqueja', response.data.idformatoqueja);
          setDeterminante(response.data);
          return response.data.municipio.idestado;
        }
      })
      .then(function (idEstado) {
        getMunicipiosList(idEstado);
        getSubCustomers();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getStatesList();
    getCustomers();
    if (idDeterminante > 0) {
      getDeterminante();
    }
    if (!formatosQueja) getFormatosQueja();
  }, []);

  useEffect(() => {
    if (selectedCustomer > 0) {
      getSubCustomers();
    }
  }, [selectedCustomer]);

  const onSubmit = data => {
    console.log(data);

    if (idDeterminante > 0) {
      httpClient(
        'put',
        URI + 'determinante/' + idDeterminante,
        {
          descripcion: data.descripcion,
          determinante: data.determinante,
          unidad: data.unidad,
          idsubcliente: data.idsubcliente,
          idmunicipio: data.idmunicipio.id ?? data.idmunicipio,
          idformatoqueja: data.formatoqueja
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
            setIsError(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'determinante',
        {
          descripcion: data.descripcion,
          determinante: data.determinante,
          unidad: data.unidad,
          idsubcliente: data.idsubcliente,
          idmunicipio: data.idmunicipio.id,
          idformatoqueja: data.formatoqueja
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };

  const getFormatosQueja = async () => {
    setFormatosQueja(null);

    httpClient('GET', URI + 'formatosqueja/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idformatoqueja, label: item.formato };
          });
          setFormatosQueja(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {customers && (
                  <Form.Group className="mb-3">
                    <Form.Label>Cliente</Form.Label>
                    <select
                      disabled={idCustomer > 0 || idDeterminante > 0}
                      aria-label="Default select"
                      name="idcustomer"
                      id="idcustomer"
                      className="form-control"
                      {...register('idcustomer', {
                        required: 'Campo Requerido'
                      })}
                      onChange={e => {
                        setValue('idcustomer', e.target.value, {
                          shouldValidate: true
                        });
                        setSelectedCustomer(e.target.value);
                      }}
                      value={`${selectedCustomer}`}
                      style={{ minWidth: '250px' }}
                    >
                      <option key={'location_0'} value="">
                        Selecciona un Cliente
                      </option>
                      {!!customers?.length &&
                        customers.map(estado => (
                          <option key={estado.value} value={estado.value}>
                            {estado.label}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      {errors.idcliente?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>SubCliente</Form.Label>
                  <select
                    aria-label="Default select"
                    name="idsubcliente"
                    id="idsubcliente"
                    className="form-control"
                    {...register('idsubcliente', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('idsubcliente', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedSubCustomer(e.target.value);
                    }}
                    value={`${selectedSubCustomer}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un SubCliente
                    </option>
                    {!!subCustomers?.length &&
                      subCustomers.map(estado => (
                        <option
                          key={estado.idsubcliente}
                          value={estado.idsubcliente}
                        >
                          {estado.descripcion}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.idsubcliente?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="10">
                <Form.Group className="mb-3">
                  <Form.Label> Determinante</Form.Label>
                  <FormControl
                    type="number"
                    {...register('determinante', {
                      required: true,
                      pattern: {
                        value: /^\d{1,5}$/,
                        message: 'La Clave debe tener menos a cuatro caracteres'
                      }
                    })}
                    defaultValue={determinante?.determinante}
                    isInvalid={!!errors.determinante}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Unidad</Form.Label>
                  <FormControl
                    type="text"
                    {...register('unidad', { required: true })}
                    defaultValue={determinante?.unidad}
                    isInvalid={!!errors.unidad}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                {formatosQueja && (
                  <Form.Group className="mb-3">
                    <Form.Label>Formato</Form.Label>
                    <select
                      aria-label="Default select"
                      name="formatoqueja"
                      id="formatoqueja"
                      className="form-control"
                      {...register('formatoqueja', {
                        required: 'Campo Requerido'
                      })}
                      onChange={e => {
                        setValue('formatoqueja', e.target.value, {
                          shouldValidate: true
                        });
                        setSelectedFormatoQueja(e.target.value);
                      }}
                      value={`${selectedFormatoQueja}`}
                      style={{ minWidth: '250px' }}
                    >
                      <option key={'location_0'} value="">
                        Selecciona un Formato
                      </option>
                      {!!formatosQueja?.length &&
                        formatosQueja.map(estado => (
                          <option key={estado.value} value={estado.value}>
                            {estado.label}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      {errors.formatoqueja?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Estado</Form.Label>
                  <select
                    aria-label="Default select"
                    name="idestado"
                    id="idestado"
                    className="form-control"
                    {...register('estado', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('estado', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedEstado(e.target.value);
                      getMunicipiosList(e.target.value);
                    }}
                    value={`${selectedEstado}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un estado
                    </option>
                    {!!states?.length &&
                      states.map(estado => (
                        <option key={estado.idestado} value={estado.idestado}>
                          {estado.descripcion}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.estado?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                {municipios && (
                  <AutocompleteDropdown
                    items={
                      !municipios
                        ? []
                        : municipios.map(municipio => {
                            return {
                              id: municipio.idmunicipio,
                              description: municipio.descripcion
                            };
                          })
                    }
                    register={register}
                    errors={errors}
                    name="idmunicipio"
                    placeholder="Selecciona un municipio"
                    currentSelected={selectedMunicipioDescription}
                    setCurrentSelected={value => {
                      setValue('idmunicipio', value, { shouldValidate: true });
                      setSelectedMunicipioDescription(value.description);
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={{ span: 10, offset: 2 }}>
                <Button variant="primary" type="submit">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
        isError={isError}
      />
    </>
  );
};
EditDeterminante.propTypes = {
  idDeterminante: PropTypes.number.isRequired,
  idCustomer: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default EditDeterminante;
